<template>
  <nav :class="['navbar-classic', { 'navbar-contrast': !isHome }]">
    <router-link to="/" class="nav-item home-link">Home</router-link>
    <router-link to="/publications" class="nav-item">Publications</router-link>
    <router-link to="/bibliography" class="nav-item">Bibliography</router-link>
    <router-link to="/pictures" class="nav-item">Pictures</router-link>
    <router-link to="/life/poems" class="nav-item">Poems</router-link>
  </nav>
</template>

<script>
export default {
  name: 'NavigationBar',
  computed: {
    isHome() {
      return this.$route.path === '/';
    }
  }
};
</script>

<style>
.navbar-classic {
  display: flex;
  justify-content: center;
  background: none;
  border-bottom: none;
  padding: 0.7rem 0;
  font-family: serif;
}

.navbar-contrast .nav-item {
  color: #2c3e50 !important;
}

.nav-item {
  color: #fff;
  margin: 0 1.2rem;
  text-decoration: none;
  font-size: 1.05rem;
  padding-bottom: 0.1rem;
  border-bottom: none;
  transition: color 0.2s;
}

.nav-item.home-link {
  font-weight: bold;
}

.nav-item.router-link-active {
  border-bottom: none;
  font-weight: bold;
}

.nav-item:hover {
  color: #8b7355;
}

@media (max-width: 768px) {
  .navbar-classic {
    flex-direction: column;
  }
  .nav-item {
    margin: 0.5rem 0;
  }
}
</style>